module.exports = __webpack_public_path__ + "static/media/webvr-frameworks-bg.ad1e9626.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/webvr-frameworks-bg.gif
// module id = 1532
// module chunks = 0